import { render, staticRenderFns } from "./ServiceTypesCategoryAutocomplete.vue?vue&type=template&id=2c1d1472"
import script from "./ServiceTypesCategoryAutocomplete.vue?vue&type=script&lang=js"
export * from "./ServiceTypesCategoryAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports